import Interval from "src/dataTypes/numeric/Interval";
import Rectangle from "src/dataTypes/geometry/Rectangle";
import List from "src/dataTypes/lists/List";
import NumberList from "src/dataTypes/numeric/NumberList";
import ListOperators from "src/operators/lists/ListOperators";
import RectangleList from "src/dataTypes/geometry/RectangleList";
import ListGenerators from "src/operators/lists/ListGenerators";
import Point from "src/dataTypes/geometry/Point";
import NumberListOperators from "src/operators/numeric/numberList/NumberListOperators";


/**
 * @classdesc Provides a set of tools that work with Rectangles
 *
 * @namespace
 * @category geometry
 */
function RectangleOperators() {}
export default RectangleOperators;

/**
 * finds the minimal rectangle containing two or more rectangles
 * @param {Rectangle} param0 first rectangle
 * @param {Rectangle} param1 second rectangle
 * @param {Rectangle} param2 third rectangle
 * @param {Rectangle} param3 fourth rectangle
 * @param {Rectangle} param4 fifth rectangle
 * @return {Rectangle}
 */
RectangleOperators.minRect = function(){
  if(arguments==null || arguments.length<1) return null;

  var i;
  var frame = arguments[0].clone();

  frame.width = frame.getRight();
  frame.height = frame.getBottom();
  for(i = 1; arguments[i] != null; i++) {
    frame.x = Math.min(frame.x, arguments[i].x);
    frame.y = Math.min(frame.y, arguments[i].y);

    frame.width = Math.max(arguments[i].getRight(), frame.width);
    frame.height = Math.max(arguments[i].getBottom(), frame.height);
  }

  frame.width -= frame.x;
  frame.height -= frame.y;

  return frame;
};

/**
 *
 * 0: quadrification
 * 1: vertical
 * 2: horizontal
 * 3: continental quadrigram (Africa, Asia, Australasia, Europe, North America, South America)
 * 4: europe quadrigram
 * 5: vertical strips quadrification
 * 6: horizontal strips quadrification
 */
RectangleOperators.packingRectangles = function(weights, packingMode, rectangle, param) {
  //TODO: return RectangleList instead of List
  if(rectangle == null) rectangle = new Rectangle(0, 0, 1, 1);
  packingMode = packingMode ? packingMode : 0;
  switch(packingMode) {
    //0: quadrification
    //1: vertical
    //2: horizontal
    //3: continental quadrigram (Africa, Asia, Australasia, Europe, North America, South America)
    //4: europe quadrigram
    //5:vertical strips
    case 0:
      return RectangleOperators.squarify(rectangle, weights);
    case 1:
      var minMax = weights.getInterval();
      if(minMax.min < 0) {
        weights = weights.add(-minMax.min);
        minMax = new Interval(0, minMax.max - minMax.min);
      }

      var sum = weights.getSum();

      var rectangleList = new List(); //RectangleList();
      var dY = rectangle.y;
      var h;
      var vFactor = rectangle.height / sum;
      var i;
      for(i = 0; weights[i] != null; i++) {
        h = vFactor * weights[i];
        rectangleList.push(new Rectangle(rectangle.x, dY, rectangle.width, h));
        dY += h;
      }
      return rectangleList;
    case 2:
      minMax = weights.getInterval();
      if(minMax.min < 0) {
        weights = weights.add(-minMax.min);
        minMax = new Interval(0, minMax.max - minMax.min);
      }
      sum = weights.getSum();

      rectangleList = new List(); //RectangleList();
      var dX = rectangle.x;
      var w;
      var hFactor = rectangle.width / sum;
      for(i = 0; weights[i] != null; i++) {
        w = hFactor * weights[i];
        rectangleList.push(new Rectangle(dX, rectangle.y, w, rectangle.height));
        dX += w;
      }
      return rectangleList;
      //var newNumberList:NumberList = OperatorsNumberList.accumulationNumberList(OperatorsNumberList.normalizeNumberListToInterval(weights, new Interval(weights.min, 1)));
    case 3:
      if(weights.length < 6) {

      } else if(weights.length == 6) {
        var rAfrica = new Rectangle(0.44, 0.36, 0.16, 0.45);
        var rAsia = new Rectangle(0.6, 0.15, 0.3, 0.3);
        var rAustralasia = new Rectangle(0.72, 0.45, 0.28, 0.32);
        var rEurope = new Rectangle(0.38, 0.04, 0.22, 0.32);

        var pivotEuroafrasia = new Point(0.6, 0.36);
        rAfrica = expandRectangle(rAfrica, Math.sqrt(weights[0]), pivotEuroafrasia);
        rAsia = expandRectangle(rAsia, Math.sqrt(weights[1]), pivotEuroafrasia);
        rEurope = expandRectangle(rEurope, Math.sqrt(weights[3]), pivotEuroafrasia);

        rAustralasia.x = rAsia.x + rAsia.width * 0.5;
        rAustralasia.y = rAsia.bottom;
        var pivotAustralasia = new Point(rAustralasia.x + rAustralasia.width * 0.3, rAsia.bottom);
        rAustralasia = expandRectangle(rAustralasia, Math.sqrt(weights[2]), pivotAustralasia);
        rAustralasia.y += rAustralasia.height * 0.2;

        var pivotAmericas = new Point(0.26, 0.36 + Math.max(rAfrica.height * 0.3, rEurope.height * 0.2));

        var rNorthAmerica = new Rectangle(0.1, pivotAmericas.y - 0.4, 0.2, 0.4);
        var rSouthAmerica = new Rectangle(0.22, pivotAmericas.y, 0.16, 0.5);

        rNorthAmerica = expandRectangle(rNorthAmerica, Math.sqrt(weights[4]), pivotAmericas);
        rSouthAmerica = expandRectangle(rSouthAmerica, Math.sqrt(weights[5]), pivotAmericas);

        var separation = Math.max(rEurope.width, rAfrica.width, rSouthAmerica.right - pivotAmericas.x, rNorthAmerica.right - pivotAmericas.x) * 0.2;
        var delta = Math.min(rEurope.x, rAfrica.x) - Math.max(rNorthAmerica.right, rSouthAmerica.right) - separation;

        rSouthAmerica.x += delta;
        rNorthAmerica.x += delta;

        return new List(rAfrica, rAsia, rAustralasia, rEurope, rNorthAmerica, rSouthAmerica); //RectangleList

      } else {

      }
    case 4:
      //return europeQuadrigram(weights);
    case 5:
      param = param || 0;
      var nLists;
      if(param === 0) {
        nLists = Math.round(Math.sqrt(weights.length));
      } else {
        nLists = Math.round(weights.length / param);
      }
      var nRows = Math.ceil(weights.length / nLists);

      var nMissing = nLists * nRows - weights.length;

      var average = weights.getAverage();
      var weigthsCompleted = ListOperators.concat(weights, ListGenerators.createListWithSameElement(nMissing, average));
      var table = ListOperators.slidingWindowOnList(weigthsCompleted, nRows, nRows, 0);
      var sumList = table.getSums();
      var rectangleColumns = this.packingRectangles(sumList, 2, rectangle);

      rectangleList = List(); //new RectangleList();

      for(i = 0; i < nLists; i++) {
        rectangleList = ListOperators.concat(rectangleList, this.packingRectangles(table[i], 1, rectangleColumns[i]));
      }

      return rectangleList;
    case 6: //horizontal strips
  }
  return null;
};

/**
 * Squarified algorithm as described in (http://www.win.tue.nl/~vanwijk/stm.pdf)
 * @param {Rectangle} bounds Rectangle
 * @param {NumberList} list of weights
 *
 * @param {Boolean} weights are normalized
 * @param {Boolean} weights are sorted
 * @return {List} a list of Rectangles
 */
RectangleOperators.squarify = function(frame, weights, isNormalizedWeights, isSortedWeights) { //, funcionEvaluacionnWeights:Function=null):Array{
  if(weights == null) return;
  if(weights.length === 0) return new RectangleList();
  if(weights.length === 1) return new RectangleList(frame);

  isNormalizedWeights = isNormalizedWeights ? isNormalizedWeights : false;
  isSortedWeights = isSortedWeights ? isSortedWeights : false;
  var newWeightList;

  if(isNormalizedWeights) {
    newWeightList = weights; // new NumberList(arregloPesos);
  } else {
    newWeightList = NumberListOperators.normalizeToSum(weights);
  }
  
  var newPositions;
  if(!isSortedWeights) {
    newPositions = weights.positions==null?newWeightList.getSortIndexes():weights.positions; // ListOperators.sortListByNumberList();// newWeightList.sortNumericIndexedDescending();
    //newWeightList = ListOperators.sortListByNumberList(newWeightList, newWeightList);
    newWeightList = newWeightList.sortedWeights==null?newWeightList.getSorted(false):newWeightList.sortedWeights;
  }

  var area = frame.width * frame.height;
  var rectangleList = new RectangleList();
  var freeRectangle = frame.clone();
  var subWeightList;
  var subRectangleList = new List(); //RectangleList();//
  var prevSubRectangleList;
  var proportion;
  var worstProportion;
  var index = 0;
  var subArea;
  var freeSubRectangle = new Rectangle();
  var nWeights = weights.length;
  var lastRectangle;
  var newRectangleList;
  var i, j;

  if(nWeights > 2) {
    var sum;
    for(i = index; i < nWeights; i++) {
      proportion = Number.MAX_VALUE;
      if(newWeightList[i] === 0) {
        rectangleList.push(new Rectangle(freeSubRectangle.x, freeSubRectangle.y, 0, 0));
      } else {
        for(j = 1; j < nWeights; j++) {
          subWeightList = NumberList.fromArray(newWeightList.slice(i, i + j)); //NumberList.fromArray(newWeightList.slice(i, i+j));//
          prevSubRectangleList = subRectangleList.slice(); //.clone();
          sum = subWeightList.getSum();
          subArea = sum * area;
          freeSubRectangle.x = freeRectangle.x;
          freeSubRectangle.y = freeRectangle.y;
          if(freeRectangle.width > freeRectangle.height) { //column
            freeSubRectangle.width = subArea / freeRectangle.height;
            freeSubRectangle.height = freeRectangle.height;
          } else { //fila
            freeSubRectangle.width = freeRectangle.width;
            freeSubRectangle.height = subArea / freeRectangle.width;
          }

          subRectangleList = RectangleOperators.partitionRectangle(freeSubRectangle, subWeightList, sum);
          worstProportion = subRectangleList.highestRatio; // RectangleOperators._getHighestRatio(subRectangleList);//
          if(proportion <= worstProportion) {
            break;
          } else {
            proportion = worstProportion;
          }
        }

        if(prevSubRectangleList.length === 0) {
          rectangleList.push(new Rectangle(freeRectangle.x, freeRectangle.y, freeRectangle.width, freeRectangle.height)); //freeRectangle.clone());
          if(rectangleList.length == nWeights) {
            if(!isSortedWeights) {
              newRectangleList = new List(); //RectangleList();
              for(i = 0; rectangleList[i] != null; i++) {
                newRectangleList[newPositions[i]] = rectangleList[i];
              }
              return newRectangleList;
            }
            return rectangleList;
          }
          index++;
        } else {
          rectangleList = rectangleList.concat(prevSubRectangleList);
          if(rectangleList.length == nWeights) {
            if(!isSortedWeights) {
              newRectangleList = new List();
              for(i = 0; rectangleList[i] != null; i++) {
                newRectangleList[newPositions[i]] = rectangleList[i];
              }
              return newRectangleList;
            }
            return rectangleList;
          }
          index += prevSubRectangleList.length;
          lastRectangle = prevSubRectangleList[prevSubRectangleList.length - 1];
          if(freeRectangle.width > freeRectangle.height) {
            freeRectangle.x = (lastRectangle.width + lastRectangle.x);
            freeRectangle.width -= lastRectangle.width;
          } else {
            freeRectangle.y = (lastRectangle.height + lastRectangle.y);
            freeRectangle.height -= lastRectangle.height;
          }
        }
        i = index - 1;
      }
    }
  } else if(nWeights == 2) {
    subWeightList = newWeightList.clone(); //.clone();
    freeSubRectangle = frame.clone();
    rectangleList = RectangleOperators.partitionRectangle(freeSubRectangle, subWeightList, subWeightList.getSum());
  } else {
    rectangleList[0] = new Rectangle(frame.x, frame.y, frame.width, frame.height); //frame.clone();
  }


  if(!isSortedWeights) {
    newRectangleList = new List(); //RectangleList();//
    for(i = 0; rectangleList[i] != null; i++) {
      newRectangleList[newPositions[i]] = rectangleList[i];
    }
    return newRectangleList;
  }

  return rectangleList;
};

/**
 * partitionRectangle
 * @param {Rectangle} bounds Rectangle
 * @param {NumberList} normalizedWeight List
 *
 * @return {List} a list of Rectangles
 */
RectangleOperators.partitionRectangle = function(rectangle, normalizedWeightList, sum) {
  var area = rectangle.width * rectangle.height;
  var rectangleList = new List(); //RectangleList();
  var freeRectangle = new Rectangle(rectangle.x, rectangle.y, rectangle.width, rectangle.height); //rectangle.clone();
  var areai;
  var i;
  var rect;
  var highestRatio = 1;
  var l = normalizedWeightList.length;
  for(i = 0; i < l; i++) {
    areai = normalizedWeightList[i] * area / sum;
    if(rectangle.width > rectangle.height) {
      rect = new Rectangle(freeRectangle.x, freeRectangle.y, areai / freeRectangle.height, freeRectangle.height);
      rectangleList.push(rect);
      freeRectangle.x += areai / freeRectangle.height;
      //rect.ratio = rect.width/rect.height;
    } else {
      rect = new Rectangle(freeRectangle.x, freeRectangle.y, freeRectangle.width, areai / freeRectangle.width);
      rectangleList.push(rect);
      freeRectangle.y += areai / freeRectangle.width;
      //rect.ratio = rect.height/rect.width;
    }
    rect.ratio = Math.max(rect.width, rect.height) / Math.min(rect.width, rect.height);
    highestRatio = Math.max(highestRatio, rect.ratio);
  }

  rectangleList.highestRatio = highestRatio;

  return rectangleList;
};

/**
 * returns the highest ratio from a list of Rectangles
 * @param {List} rectangleList a Rectangle List
 *
 * @return {Number} highestRatio
 */
RectangleOperators._getHighestRatio = function(rectangleList) {
  var highestRatio = 1;
  var rectangle;
  var i;
  for(i = 0; i < rectangleList.length; i++) {
    rectangle = rectangleList[i];
    highestRatio = Math.max(highestRatio, rectangle.getRatio());
  }
  return highestRatio;
};

/**
 * makeRectanglesNonOverlapping
 * @param {RectangleList} rL0 is a list of Rectangles
 * @param {Rectangle} rBoundary is the boundary of allowed space
 *
 * @param {Number} fPad is the minimum spacing between rectangles
 *
 * @return {RectangleList} a list of Rectangles which do not overlap unless they do not fit otherwise
 */
RectangleOperators.makeRectanglesNonOverlapping = function(rL0,rBoundary,fPad){
  var rLNonOverlap = new RectangleList();
  if(fPad == null) fPad=0;
  var i,rItem,dx,dy;
  for(i=0; i<rL0.length; i++){
    rItem = rL0[i].clone();
    dx = Math.max(2,rItem.width*.1);
    dy = Math.max(2,rItem.height*.1);
    RectangleOperators.placeRectangleAvoidingOthers(rItem,rBoundary,rLNonOverlap,fPad,dx,dy);
    rLNonOverlap.push(rItem);
  }
  return rLNonOverlap;
};

/**
 * placeRectangleAvoidingOthers
 * @param {Rectangle} rItem is the location and size of a rectangle
 * @param {Rectangle} rBoundary is the boundary of allowed space
 * @param {RectangleList} rLAvoid is a list of Rectangles already place which must be avoided
 * @param {Number} fPad is the minimum spacing between rectangles
 * @param {Number} dx is the horizontal increment
 * @param {Number} dy is the vertical increment
 *
 * @return {Boolean} true if it fits, rItem will be set to new location
 */
RectangleOperators.placeRectangleAvoidingOthers = function(rItem, rBoundary, rLAvoid, fPad, dx, dy)
{
  // r is boundary rectangle, rItem is starting location for desired item, fPad is padding
  // rLAvoid has items already placed that we need to check for overlap
  // rItem comes in with desired location, ends up with closest to it that will fit
  if(isNaN(rItem.x) || isNaN(rItem.y)) return false;
  if(rItem.width > rBoundary.width || rItem.height > rBoundary.height) return false;
  var x0 = rItem.x;
  var y0 = rItem.y;
  // make sure is inside rBoundary to start
  if(rItem.getBottom() < rBoundary.y)
    rItem.y = rBoundary.y;
  else if(rItem.y > rBoundary.getBottom())
    rItem.y = rBoundary.getBottom() - rItem.height;
  if(rItem.getRight() < rBoundary.x)
    rItem.x = rBoundary.x;
  else if(rItem.x > rBoundary.getRight())
    rItem.x = rBoundary.getRight() - rItem.width;

  var idir = rLAvoid.length%2 == 0?2:4; // 1 - right, 2 - down, 3 - left, 4 - up
  var iSteps = 0;
  var iStepLimit = 1;

  var rBoundHit = new Rectangle();
  var rTestInner = new Rectangle();
  if(dy == 0){
    rBoundHit.y = rBoundHit.height = 1;
  }
  if(dx == 0){
    rBoundHit.x = rBoundHit.width = 1;
  }
  var iPrevInt = -1;
  var rTest = new Rectangle();
  while(rBoundHit.x*rBoundHit.y*rBoundHit.width*rBoundHit.height == 0){
    if(rItem.x < rBoundary.x) rBoundHit.x = 1;
    if(rItem.y < rBoundary.y) rBoundHit.y = 1;
    if(rItem.x > rBoundary.x+rBoundary.width) rBoundHit.width = 1;
    if(rItem.y > rBoundary.y+rBoundary.height) rBoundHit.height = 1;
    if(rBoundary.containsRectangle(rItem)){
      // check all other placed items for overlap with this one
      var bOverlap = false;
      rTest.x = rItem.x - fPad/2;
      rTest.width = rItem.width + fPad;
      rTest.y = rItem.y - fPad/2;
      rTest.height = rItem.height + fPad;
      if(iPrevInt != -1 && rTest.intersectsRectangle(rLAvoid[iPrevInt])){
        bOverlap=true;
      }
      for(var i=0; i < rLAvoid.length && !bOverlap; i++){
        if(rTest.intersectsRectangle(rLAvoid[i])){
          bOverlap=true;
          iPrevInt = i;
          break;
        }
      }
      if(!bOverlap){
        return true;
      }
    }
    if(dx == 0 && (idir == 1 || idir == 3))
      iSteps = iStepLimit;
    else if(dy == 0 && (idir == 2 || idir == 4))
      iSteps = iStepLimit;
    // spiral direction change
    if(iSteps >= iStepLimit){
      if(idir == 1 || idir == 3)
        iStepLimit++;
      idir++;
      if(idir > 4)
        idir = 1;
      iSteps = 0;
    }
    if(idir == 1)
      rItem.x += dx;
    else if(idir == 2)
      rItem.y += dy;
    else if(idir == 3)
      rItem.x -= dx;
    else if(idir == 4)
      rItem.y -= dy;
    iSteps++;
  }
  rItem.x = x0;
  rItem.y = y0;
  return false;
};
